import React, { useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import {
  Autocomplete,
  AutocompleteHighlighter,
} from '../../../../../Inputs/AutocompleteInput';
import { formatUserFullName } from '@uplift/utils';
import { usePatients } from './PatientsAutocomplete.hooks';
import { useCurrentuser } from '@uplift/contexts';

// TODO: simplify, use type instead of infer
type _patientResponse = ReturnType<typeof usePatients>[0];
const patientSearchFilter = (options: _patientResponse[], { inputValue }: { inputValue: string }) => {
  const terms = inputValue.trim().toLowerCase().split(' ');

  return options.filter(opt =>
    terms.every(term =>
      opt.firstName?.toLowerCase()?.includes(term)
      || opt.lastName?.toLowerCase()?.includes(term)
      || opt.preferredName?.toLowerCase()?.includes(term)
    )
  );
};


export type PatientSearchAutocompleteProps = {
  name: string;
  label?: string;
  autoFocus?: boolean;
  placeholder?: string;
  disablePortal?: boolean;
  ['data-testid']?: string;
};


export const PatientSearchAutocomplete: React.VFC<PatientSearchAutocompleteProps> = (props) => {
  const me = useCurrentuser();
  const patients = usePatients(me.id);
  const handleRenderOption = useCallback((option, state) => (
    <Box display="flex" flexDirection="column">
      <Typography>
        <AutocompleteHighlighter text={formatUserFullName({ ...option, preferredFirstName: option.preferredName })} highlight={state.inputValue} color="secondary" />
      </Typography>
    </Box>
  ), []);

  return (
    <Box position="relative" width="100%">
      <Autocomplete
        fullWidth
        disablePortal
        options={patients || []}
        getOptionLabel={option => formatUserFullName({ ...option, preferredFirstName: option.preferredName })}
        renderOption={handleRenderOption}
        filterOptions={patientSearchFilter}
        {...props}
      />
    </Box>
  );
};
